export var LockOutcome;
(function (LockOutcome) {
  /**
   * The requester has won access to the lock and should perform the operation
   * that needed to be locked.
   */
  LockOutcome["WINNER"] = "WINNER";
  /**
   * Someone else won the lock and has completed the operation successfully
   */
  LockOutcome["DELEGATED_SUCCESS"] = "DELEGATED_SUCCESS";
  /**
   * Someone else won the lock and has encountered an error while performing the operation
   */
  LockOutcome["DELEGATED_FAILURE"] = "DELEGATED_FAILURE";
  /**
   * We have exceeded the maximum number of _consecutive_ failures allowed for the operation
   */
  LockOutcome["RETRIES_EXCEEDED"] = "RETRIES_EXCEEDED";
})(LockOutcome || (LockOutcome = {}));
const winnerPayload = releaseLock => ({
  outcome: LockOutcome.WINNER,
  success: extraData => releaseLock(true, extraData),
  fail: extraData => releaseLock(false, extraData)
});
const delegatePayload = (success, extraData) => ({
  outcome: success ? LockOutcome.DELEGATED_SUCCESS : LockOutcome.DELEGATED_FAILURE,
  ...extraData
});
const retriesExceededPayload = () => ({
  outcome: LockOutcome.RETRIES_EXCEEDED
});
export class Lock {
  constructor() {
    let maxRetries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    this.locked = false;
    this.queue = [];
    this.retries = 0;
    this.maxRetries = 0;
    this.maxRetries = maxRetries;
  }
  /**
   * Obtain a lock if it's available. If not, then this will resolve
   * as soon as the locking worker resolves.
   *
   * TODO: Make the response not include `& any`
   */
  lockOrAwaitLock() {
    return new Promise(resolve => {
      if (this.maxRetries > 0 && this.retries >= this.maxRetries) {
        resolve(retriesExceededPayload());
        return;
      }
      if (this.locked) {
        this.queue.push(resolve);
      } else {
        this.locked = true;
        this.retries++;
        resolve(winnerPayload(this.releaseLock.bind(this)));
      }
    });
  }
  /**
   * Callback for after a locked operation completes. Will take care
   * of notifying everyone waiting in the queue.
   *
   * @private
   * @param success Whether the operation was successful
   * @param extraData Data to include when notifying all those in the queue
   */
  releaseLock(success, extraData) {
    this.locked = false;
    // If we're successful, then reset the retry count
    if (success) {
      this.retries = 0;
    }
    let item;
    while (item = this.queue.pop()) {
      item(delegatePayload(success, extraData));
    }
  }
}